export default {
  APPLICATION_SHOW_MODAL: 'APPLICATION_SHOW_MODAL',
  APPLICATION_FETCH_COMMONS_DATA: 'APPLICATION_FETCH_COMMONS_DATA',
  APPLICATION_HIDE_MODAL: 'APPLICATION_HIDE_MODAL',
  APPLICATION_SET_LOADING: 'APPLICATION_SET_LOADING ',
  APPLICATION_SET_MODAL_LOADING: 'APPLICATION_SET_MODAL_LOADING ',
  APPLICATION_CLEAN_STATE: 'APPLICATION_CLEAN_STATE',
};
